import React, { Component } from 'react'
import { Fragment } from 'react'
import AppURL from '../api/AppURL'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import axios from 'axios'
import SearchList from '../components/ProductDetails/SearchList'
import { useParams } from 'react-router-dom';

function SearchPageWrapper(props) {
     // useParams ব্যবহার করে category প্যারামিটার পাওয়া হচ্ছে
     const { searchkey } = useParams();
     return <SearchPage {...props} searchkey={searchkey} />;
}

class SearchPage extends Component {

     constructor(props){
          super(props);
          this.state={
               SearchKey:props.searchkey,
               ProductData:[] 
          }
     }


  
     componentDidMount(){
          window.scroll(0,0)
          // alert(this.state.Category);
          axios.get(AppURL.ProductBySearch(this.state.SearchKey)).then(response =>{
               
               this.setState({ProductData:response.data});         

          }).catch(error=>{

          });

     } 

     render() {
          return (
               <Fragment> 
               <div className="Desktop">
                <NavMenuDesktop /> 
               </div>

               <div className="Mobile">
               <NavMenuMobile />  
               </div>                       

               <SearchList SearchKey={this.state.SearchKey} ProductData={this.state.ProductData} /> 
               
               <div className="Desktop">
               <FooterDesktop/>
               </div>

               <div className="Mobile">
               <FooterMobile/>
               </div>
               
          </Fragment>
          )
     }
}

export default SearchPageWrapper;
